import {useTranslation} from 'next-i18next';
import {EmptyState} from './EmptyState';

export const NoDataInformation = () => {
  const {t} = useTranslation();
  return <EmptyState title={t('common:noData')} />;
};
